import {
  ApiListing,
  ApiListingsResponse,
  ApiResponse,
} from "../../types/apiTypes";
import {
  Listing,
  ListingFilters,
  ListingImage,
} from "../../types/listingTypes";
import { apiRequest } from "../client";
import { API_ENDPOINTS } from "../config";

// API functions
export const listingsApi = {
  getListings: async (
    filters: ListingFilters = {}
  ): Promise<ApiResponse<ApiListingsResponse>> => {
    return apiRequest({
      url: API_ENDPOINTS.LISTINGS,
      method: "GET",
      params: filters,
    });
  },

  getListing: async (id: string): Promise<ApiResponse<ApiListing>> => {
    return apiRequest({
      url: API_ENDPOINTS.LISTING_DETAIL(id),
      method: "GET",
    });
  },

  createListing: async (
    listing: Partial<Listing>
  ): Promise<ApiResponse<ApiListing>> => {
    return apiRequest({
      url: API_ENDPOINTS.LISTINGS,
      method: "POST",
      data: listing,
    });
  },

  updateListing: async (
    id: string,
    listing: Partial<Listing>
  ): Promise<ApiResponse<ApiListing>> => {
    return apiRequest({
      url: API_ENDPOINTS.LISTING_DETAIL(id),
      method: "PUT",
      data: listing,
    });
  },

  deleteListing: async (id: string): Promise<ApiResponse<void>> => {
    return apiRequest({
      url: API_ENDPOINTS.LISTING_DETAIL(id),
      method: "DELETE",
    });
  },

  boostListing: async (
    id: string,
    boostOption: string
  ): Promise<
    ApiResponse<{
      success: boolean;
      listing: ApiListing;
      pointsUsed: number;
      remainingPoints: number;
      boostedUntil: string;
    }>
  > => {
    return apiRequest({
      url: API_ENDPOINTS.BOOST_LISTING(id),
      method: "POST",
      data: { boostOption },
    });
  },

  featureListing: async (
    id: string,
    featureOption: string
  ): Promise<
    ApiResponse<{
      success: boolean;
      listing: ApiListing;
      pointsUsed: number;
      remainingPoints: number;
      featuredUntil: string;
    }>
  > => {
    return apiRequest({
      url: API_ENDPOINTS.FEATURE_LISTING(id),
      method: "POST",
      data: { featureOption },
    });
  },

  getUserListings: async (): Promise<ApiResponse<ApiListing[]>> => {
    return apiRequest({
      url: `${API_ENDPOINTS.LISTINGS}/user`,
      method: "GET",
    });
  },

  uploadListingImage: async (
    listingId: string | number,
    imageFile: File
  ): Promise<ApiResponse<{ image: ListingImage }>> => {
    const formData = new FormData();
    formData.append("image", imageFile);

    return apiRequest({
      url: API_ENDPOINTS.UPLOAD_LISTING_IMAGE(listingId),
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  deleteListingImage: async (
    listingId: string | number,
    imageId: string | number
  ): Promise<ApiResponse<void>> => {
    return apiRequest({
      url: API_ENDPOINTS.DELETE_LISTING_IMAGE(listingId, imageId),
      method: "DELETE",
    });
  },
};
